import {normalize} from 'normalizr';
import * as schema from './schemas';
import {actions} from '../actions';

const initialState = {};

/* eslint-disable camelcase */
export default function inputsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.STEPS.FETCH_FULFILLED: {
      const {step} = action.payload;
      const {
        entities: {inputs, other_inputs},
      } = normalize(step, schema.Step);

      return {...state, ...inputs, ...other_inputs};
    }

    case actions.QUESTIONS.FETCH_FULFILLED: {
      const {question} = action.payload;
      const {
        entities: {inputs, other_inputs},
      } = normalize(question, schema.Question);

      return {...other_inputs, ...inputs, ...state};
    }

    case actions.INPUTS.UPDATE_VALUE: {
      const {inputHandle, value} = action.payload;
      const input = state[inputHandle];
      if (!input) {
        return state;
      }
      const otherInputIds = getOtherInputIds(input.options, value);

      return {
        ...state,
        [inputHandle]: {
          ...input,
          otherInputIds,
          value,
        },
      };
    }

    case actions.VALIDATION.INPUT_VALID: {
      const {inputHandle} = action.payload;

      return {
        ...state,
        [inputHandle]: {
          ...state[inputHandle],
          error: null,
        },
      };
    }

    case actions.VALIDATION.INPUT_INVALID: {
      const {inputHandle, error} = action.payload;

      return {
        ...state,
        [inputHandle]: {
          ...state[inputHandle],
          error: error.message,
        },
      };
    }

    case actions.PROGRESS.RESET_SERVICE_SELECTION: {
      const {inputHandles = []} = action.payload;

      return inputHandles.reduce((newState, handle) => {
        if (state[handle]) {
          newState[handle] = {...state[handle]};
        }
        return newState;
      }, {});
    }
  }

  return state;
}
/* eslint-enable camelcase */

/**
 * Other Input ID's are stored within options of a particular
 * input. Given an a set of options and an input's value this
 * function will return any other input ID's which are currently
 * selected.
 *
 * @param {Array} options
 * @param {Array | String} value
 * @returns {*}
 */
function getOtherInputIds(options, value) {
  return (options || []).reduce((otherIds, option) => {
    if (option.otherId && isOptionSelected(option, value)) {
      return [...otherIds, option.otherId];
    }

    return otherIds;
  }, []);
}

function isOptionSelected(option, inputValue) {
  return (
    inputValue === option.value ||
    (Array.isArray(inputValue) && inputValue.includes(option.value))
  );
}
